var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "full-screen" }, [
    _c(
      "div",
      { staticClass: "button-row" },
      _vm._l(_vm.dimensions, function(dim) {
        return _c(
          "div",
          {
            key: dim.name,
            staticClass: "dimension-button",
            class: dim.selected ? "on" : "off",
            on: {
              click: function($event) {
                return _vm.selectDimension(dim)
              }
            }
          },
          [_c("img", { attrs: { src: dim.imageURL } })]
        )
      }),
      0
    ),
    _vm._v(" "),
    _vm.ask
      ? _c("div", { staticClass: "button-row" }, [
          !_vm.ask.excludeFromAI
            ? _c(
                "div",
                {
                  staticClass: "gemini-btn wide",
                  staticStyle: { "flex-grow": "3" },
                  on: {
                    click: function($event) {
                      return _vm.excludeFromAI()
                    }
                  }
                },
                [_vm._v("\n\t\t\t\tExclude from AI\n\t\t\t")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.ask.excludeFromAI
            ? _c(
                "div",
                {
                  staticClass: "gemini-btn wide",
                  staticStyle: {
                    "flex-grow": "3",
                    "text-decoration": "line-through",
                    color: "maroon"
                  },
                  on: {
                    click: function($event) {
                      return _vm.excludeFromAI()
                    }
                  }
                },
                [_c("i", [_vm._v("Excluded from AI")])]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "gemini-btn wide",
              staticStyle: { "flex-grow": "3", "font-size": "22px" },
              style: "color: " + (_vm.ask.stars == 1 ? "purple" : "#bbbbbb"),
              on: {
                click: function($event) {
                  return _vm.rateAsk(1)
                }
              }
            },
            [_vm._v("★")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "gemini-btn wide",
              staticStyle: { "flex-grow": "3", "font-size": "22px" },
              style: "color: " + (_vm.ask.stars == 2 ? "purple" : "#bbbbbb"),
              on: {
                click: function($event) {
                  return _vm.rateAsk(2)
                }
              }
            },
            [_vm._v("★★")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "gemini-btn wide",
              staticStyle: { "flex-grow": "3", "font-size": "22px" },
              style: "color: " + (_vm.ask.stars == 3 ? "purple" : "#bbbbbb"),
              on: {
                click: function($event) {
                  return _vm.rateAsk(3)
                }
              }
            },
            [_vm._v("★★★")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "gemini-btn wide",
              staticStyle: { "flex-grow": "3", "font-size": "22px" },
              style: "color: " + (_vm.ask.stars == 4 ? "purple" : "#bbbbbb"),
              on: {
                click: function($event) {
                  return _vm.rateAsk(4)
                }
              }
            },
            [_vm._v("★★★★")]
          ),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.deadline,
                expression: "deadline"
              }
            ],
            staticClass: "gemini-btn wide",
            staticStyle: { "flex-grow": "1" },
            attrs: { type: "date", alt: "Deadline" },
            domProps: { value: _vm.deadline },
            on: {
              change: function($event) {
                return _vm.addDeadline()
              },
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.deadline = $event.target.value
              }
            }
          })
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "button-row" }, [
      _c(
        "div",
        {
          staticClass: "gemini-btn wide",
          staticStyle: { "flex-grow": "1" },
          on: {
            click: function($event) {
              return _vm.nextAsk("back")
            }
          }
        },
        [_vm._v("\n\t\t\t\t<\n\t\t\t")]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "gemini-btn wide",
          staticStyle: { "flex-grow": "1" },
          on: {
            click: function($event) {
              return _vm.nextAsk("next")
            }
          }
        },
        [_vm._v("\n\t\t\t\t>\n\t\t\t")]
      ),
      _vm._v(" "),
      _c(
        "select",
        {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.ask.intent,
              expression: "ask.intent"
            }
          ],
          staticClass: "gemini-btn wide",
          staticStyle: { "flex-grow": "3" },
          on: {
            change: [
              function($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function(o) {
                    return o.selected
                  })
                  .map(function(o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.$set(
                  _vm.ask,
                  "intent",
                  $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                )
              },
              function($event) {
                return _vm.pickIntent()
              }
            ]
          }
        },
        _vm._l(_vm.intents, function(intent) {
          return _c("option", { key: intent }, [_vm._v(_vm._s(intent))])
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "gemini-btn wide",
          staticStyle: { "flex-grow": "3" },
          on: {
            click: function($event) {
              return _vm.clearLabels()
            }
          }
        },
        [_vm._v("\n\t\t\t\tClear Labels\n\t\t\t")]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "gemini-btn wide",
          staticStyle: { "flex-grow": "3" },
          on: {
            click: function($event) {
              return _vm.addAILabels()
            }
          }
        },
        [_vm._v("\n\t\t\t\t" + _vm._s(_vm.aiText) + "\n\t\t\t")]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "gemini-btn wide",
          staticStyle: { "flex-grow": "3" },
          on: {
            click: function($event) {
              return _vm.goToMatches()
            }
          }
        },
        [
          _vm._v(
            "\n\t\t\t\tMatches (" +
              _vm._s(
                _vm.ask.recommendedAdvisors
                  ? _vm.ask.recommendedAdvisors.length
                  : 0
              ) +
              ")\n\t\t\t"
          )
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "details" }, [
      _c("b", [_vm._v(_vm._s(_vm.getStatus()))]),
      _vm._v(
        " for\n\t\t\t" +
          _vm._s(_vm.community.name) +
          ".\n\t\t\t" +
          _vm._s(
            _vm.ask.recommendedAdvisors ? _vm.ask.recommendedAdvisors.length : 0
          ) +
          "\n\t\t\tmatches. Last Request Sent: " +
          _vm._s(_vm.tinyDate(_vm.ask.reqSentDate)) +
          ", Received:\n\t\t\t" +
          _vm._s(_vm.tinyDate(_vm.ask.reqReceivedDate)) +
          "\n\t\t"
      )
    ]),
    _vm._v(" "),
    _c(
      "p",
      {
        ref: "annotator",
        staticClass: "ask",
        style:
          "border-top-style:" +
          (_vm.loading
            ? "dashed; border-top-color:red"
            : "dotted; border-top-color:green") +
          ";",
        on: {
          touchend: function($event) {
            return _vm.tag($event)
          },
          pointerup: function($event) {
            return _vm.tag($event)
          }
        }
      },
      [_vm._v("\n\t\t\t" + _vm._s(_vm.untaggedText) + "\n\t\t")]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5fc4caba", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5fc4caba","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/gemini/AITrainer.vue
// module id = null
// module chunks = 